<div class="debug-dashboard">
  <h2>Debug Dashboard</h2>
  <div class="logs-container">
    <table>
      <thead>
        <tr>
          <th>Timestamp</th>
          <th>Level</th>
          <th>Message</th>
          <th>Context</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let log of logs$ | async" [ngClass]="getLogLevelName(log.level).toLowerCase()">
          <td>{{ log.timestamp | date:'medium' }}</td>
          <td>{{ getLogLevelName(log.level) }}</td>
          <td>{{ log.message }}</td>
          <td><pre>{{ log.context | json }}</pre></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
